export default __webpack_public_path__ + "static/media/Pay Per Night - Grey.84f25ef1.svg";